import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';
import {Outlay} from '../model/outlay';

@Injectable()
export class OutlayService {

    constructor(private api: ApiService) { }

    findOutlay(pkPortal: number, pkService: number, criteria: Object): Observable<Object> {

        const url = 'vna/portal/' + pkPortal + '/service/' + pkService + '/outlay';
        return this.api.get(url, criteria);
    }

    findOutlayEvolution(pkPortal: number, pkService: number, criteria: Object): Observable<Object> {

        const url = 'vna/portal/' + pkPortal + '/service/' + pkService + '/outlay-evolution';
        return this.api.get(url, criteria);
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/outlay/services/outlay.service.ts